(() => {
  if (customElements.get('cart-button-total')) return;

  class CartButtonTotal extends HTMLElement {
    connectedCallback() {
      const priceHolder = this.closest('cart-element')?.querySelector('[data-cart-price-holder]');
      if (!priceHolder) return;

      const update = () => {
        const total = priceHolder.querySelector('[data-cart-total]')?.getAttribute('data-cart-total');
        if (total === null || total === undefined) return;

        let formatted = window.theme.formatMoney(Number(total), window.theme.moneyWithCurrencyFormat);
        if (this.dataset.currency === 'CLP') formatted = formatted.replace(/,/g, '.');
        this.innerHTML = formatted;
      };

      this.observer = new MutationObserver(update);
      this.observer.observe(priceHolder, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-cart-total'] });
      update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('cart-button-total', CartButtonTotal);
})();
